export var hasHeader = function hasHeader(soughtHeader, headers) {
  soughtHeader = soughtHeader.toLowerCase();
  for (var _i = 0, _Object$keys = Object.keys(headers); _i < _Object$keys.length; _i++) {
    var headerName = _Object$keys[_i];
    if (soughtHeader === headerName.toLowerCase()) {
      return true;
    }
  }
  return false;
};
export var getHeaderValue = function getHeaderValue(soughtHeader, headers) {
  soughtHeader = soughtHeader.toLowerCase();
  for (var _i2 = 0, _Object$keys2 = Object.keys(headers); _i2 < _Object$keys2.length; _i2++) {
    var headerName = _Object$keys2[_i2];
    if (soughtHeader === headerName.toLowerCase()) {
      return headers[headerName];
    }
  }
  return undefined;
};
export var deleteHeader = function deleteHeader(soughtHeader, headers) {
  soughtHeader = soughtHeader.toLowerCase();
  for (var _i3 = 0, _Object$keys3 = Object.keys(headers); _i3 < _Object$keys3.length; _i3++) {
    var headerName = _Object$keys3[_i3];
    if (soughtHeader === headerName.toLowerCase()) {
      delete headers[headerName];
    }
  }
};